(function () {
  if (!/(^|\.)cookdinehost\.com$/.test(location.hostname)) return;
  var started = false;
  var scheduled = false;
  var pending = null;
  var granted = true;

  function consented() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (_) {
      return false;
    }
  }

  function allowed() {
    return document.visibilityState === 'visible' && consented();
  }

  function start() {
    pending = null;
    if (!allowed()) {
      scheduled = false;
      return;
    }
    if (started) return;
    started = true;
    scheduled = false;
    removeEventListener('visibilitychange', boot);
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'vlna552pqu');
  }

  function boot() {
    if (started) {
      if (consented() !== granted) {
        granted = !granted;
        window.clarity('consent', granted);
      }
      return;
    }
    if (!allowed()) {
      if (pending !== null) {
        if ('cancelIdleCallback' in window) cancelIdleCallback(pending);
        else clearTimeout(pending);
      }
      pending = null;
      scheduled = false;
      return;
    }
    if (scheduled) return;
    scheduled = true;
    if ('requestIdleCallback' in window) {
      pending = requestIdleCallback(start, { timeout: 3000 });
    } else {
      pending = setTimeout(start, 1500);
    }
  }

  addEventListener('visibilitychange', boot);
  document.addEventListener('visitorConsentCollected', boot);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: boot }]);
  }
})();
